export enum IPMFileType {
  IpmFile = 'IPM File',
  Folder = 'folder',
}

export interface IIPMFile {
  id: string;
  name: string;
  data: string;
  value: string;
  type: IPMFileType;
  parentId?: string | number;
}

export interface ISettingsState {
  isFetching: boolean;
  data: IIPMFile[];
  error: string;
}
